import styled from 'styled-components';
import { withLinkUnderlined } from 'app/theme';
import { SectionEntityDetails } from 'app/components/Entity';
import { textTransform } from 'utils';

export default styled(SectionEntityDetails).attrs({
  className: 's-cinema-details'
})`
  .s-cinema-details__nav-tabs {
    display: none;
    width: 100%;
    /* margin-bottom: ${({ theme }) => theme.indent.m}; */
    margin:12px 0px;
  }

  .s-cinema-details__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* margin-bottom: ${({ theme }) => theme.indent.l}; */
    margin-bottom: -5px;
  }

  .s-cinema-details__header-inner,
  .l-social {
    padding-right: ${({ theme }) => theme.indent.l};
    margin-bottom:10px;
  }

  .s-cinema-details__title {
    display: flex;
    font-size: 2.4rem;
    font-weight: 700;
    line-height: 1.42;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
    color: ${({ theme }) => theme.color.accent};

    .btn-favorite {
      margin: 3px ${({ theme }) => theme.indent.s} 0 0;
      padding: 2px 0px;
      width: 24px;
      height: 24px;
    }
  }

  .s-cinema-details__address {
    margin-top: 5px;

    .svg-location {
      vertical-align: top;
      width: 0.875em;
      height: 1.3em;
      margin-top: 0.2em;
      fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
    }
  }

  .s-cinema-details__address-inner {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 14px);
    padding-left: ${({ theme }) => theme.indent.s};
  }

  .s-cinema-details__address-text {
    display: inline;
    vertical-align: middle;
    margin-right: ${({ theme }) => theme.indent.s};
    font-size: 1.6rem;
    line-height: 1.25;
    color: ${({ theme }) => theme.color.textPrimary};
    transition: color 0.2s ease-out;
  }

  .s-cinema-details__address-link {
    vertical-align: middle;
    margin-right: ${({ theme }) => theme.indent.s};
  }

  .s-cinema-details__address-btn-map {
    vertical-align: middle;
    font-size: 1.6rem;
    // color: ${({ theme }) => theme.color.textPrimary};
    color:#DE1619;
    ${withLinkUnderlined}
  }

  .s-cinema-details__link-prices {
    display: inline-block;
    margin-top: 5px;
    color: ${({ theme }) => theme.color.accent};

    &:hover .s-cinema-details__link-prices-text {
      text-decoration: underline;
      color:#DE1619;
    }

    .s-cinema-details__link-prices-text {
      vertical-align: -0.22em;
      font-size: 1.6rem;
      font-weight: 500;
      text-transform: ${textTransform};
    }

    .svg-document {
      vertical-align: middle;
      margin: 0 2px 0 -4px;
      width: 24px;
      height: 24px;
      // fill: ${({ theme }) => theme.color.rgbaWhite('.8')};
      fill:#DE1619;
    }
  }

  ._logged .s-cinema-details__address,
  ._logged .s-cinema-details__link-prices {
    margin-left: 32px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    .s-cinema-details__title {
      font-size: 2rem;
    }

    .s-cinema-details__nav-tabs {
      display: block;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    .s-cinema-details__header {
      display: block;
    }

    .s-cinema-details__header-inner {
      margin: 10px;
    }

    .l-social {
      padding-right: 0;
      margin-top: ${({ theme }) => theme.indent.s};
    }

    ._logged .l-social {
      margin-left: ${({ theme }) => theme.indent.l};
    }

    .l-social + .b-movies-filter {
      margin-top: ${({ theme }) => theme.indent.m};
    }

    .b-movies-filter {
      margin-top: ${({ theme }) => theme.indent.l};
    }

    .s-cinema-details__title {
      font-size: 1.5rem;

      .btn-favorite {
        margin: -2px ${({ theme }) => theme.indent.s} 0 0;
      }
    }

    .s-cinema-details__address-text,
    .s-cinema-details__address-link,
    .s-cinema-details__address-btn-map {
      font-size: 1.4rem;
    }
  }
`;
